/**
 * VehicleSceneTimeline tab — wrapper for the sidebar tab
 */
import VehicleSceneTimelinePage from '../components/vehicleSceneTimeline/VehicleSceneTimelinePage';

export default function VehicleSceneTimeline() {
  return <VehicleSceneTimelinePage />;
}
